module.exports = __webpack_public_path__ + "static/media/for-sale-bro-building.af44280b.svg";